import { Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { getCandidateDeleteRequest } from 'wisestep-api';
import { Label, WsColors } from 'wisestep-base';

import SettingsIndex from '../../../components/SettingsIndex';
import { AppLayoutTheme } from '../../../features/candidates/utils/CandidateHelper';
import { lazyImport } from '../../../utils/lazyImport';
import useCandidateAccess from '../hooks/useCandidateAccess';
import useGDPRSettings from '../hooks/useGDPRSettings';
import CandidateDataProvider from '../providers/CandidateDataProvider';

import DataProtectionPendingDeleteRequest from './DataProtectionPendingDeleteRequest';
const { GDPRRoutes } = lazyImport(() => import('../childRoutes'), 'GDPRRoutes');

export type GdprSettingsParam = {
  companyId: string;
  companyName: string;
};

const DataProtectionLayout = () => {
  const params = useParams<GdprSettingsParam>();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('candidateEmail') ?? '';
  const otp = searchParams.get('otpCode');
  const [settings] = useGDPRSettings(params.companyId ?? '');
  const [accessInfo, isSuccess] = useCandidateAccess({
    email: email ?? '',
    otp: otp ?? '',
    companyId: params.companyId ?? '',
    companyName: settings?.companyName ?? params.companyName ?? 'companyName',
  });
  const [pendingDeleteRequest, setPendingDeleteRequest] = useState<boolean>(false);
  useEffect(() => {
    const getCandidateDeleteReq = async () => {
      try {
        const response = await getCandidateDeleteRequest(email, params.companyId ?? '');
        if (!isEmpty(response.data)) setPendingDeleteRequest(true);
      } catch (e) {
        console.log(e);
      }
    };
    getCandidateDeleteReq();
  }, [email, params.companyId]);
  const userParams = searchParams.toString();
  return (
    <>
      {pendingDeleteRequest ? (
        <DataProtectionPendingDeleteRequest />
      ) : (
        <>
          <AppLayoutTheme mx={4} my={2} p={3}>
            <Label sx={{ fontSize: 28, fontWeight: 'bold', color: WsColors.White }}>
              {settings?.companyName}
            </Label>
          </AppLayoutTheme>

          <Grid container height="70vh" columnGap={10} mx={4} my={2}>
            {isSuccess && (
              <CandidateDataProvider accessInfo={accessInfo} settings={settings}>
                <Grid item justifyContent="center" xs={12} display="flex">
                  <Label sx={{ fontSize: 24, fontWeight: 'bold' }}>
                    Data Protection And Privacy Settings Page
                  </Label>
                </Grid>
                <Grid xs={2} mt={3} item height="100%" sx={{ backgroundColor: WsColors.White }}>
                  <SettingsIndex
                    options={[
                      {
                        label: 'View',
                        url: `/data-protection/${params.companyName}/${params.companyId}/view?${userParams}`,
                      },
                      {
                        label: '',
                        url: '',
                      },
                      {
                        label: 'Update',
                        url: `/data-protection/${params.companyName}/${params.companyId}/update?${userParams}`,
                      },
                      {
                        label: '',
                        url: '',
                      },
                      {
                        label: 'Restrict',
                        url: `/data-protection/${params.companyName}/${params.companyId}/restrict?${userParams}`,
                      },
                      {
                        label: '',
                        url: '',
                      },
                      {
                        label: 'Delete',
                        url: `/data-protection/${params.companyName}/${params.companyId}/delete?${userParams}`,
                      },
                      {
                        label: '',
                        url: '',
                      },
                    ]}
                  />
                </Grid>
                <Grid
                  xs={9}
                  p={2}
                  item
                  height="100%"
                  px={2}
                  mt={3}
                  sx={{ backgroundColor: WsColors.White }}
                >
                  <GDPRRoutes />
                </Grid>
              </CandidateDataProvider>
            )}
          </Grid>
        </>
      )}
    </>
  );
};

export default DataProtectionLayout;
